import { render } from "./AssetGroupDetailsView.vue?vue&type=template&id=4d5b248e&scoped=true&ts=true"
import script from "./AssetGroupDetailsView.vue?vue&type=script&lang=ts"
export * from "./AssetGroupDetailsView.vue?vue&type=script&lang=ts"

import "./AssetGroupDetailsView.vue?vue&type=style&index=0&id=4d5b248e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d5b248e"]])

export default __exports__